/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
export const gmaoInputDateComponent = {
    template: require('./gmao-input-date.html'),
    bindings: {
        model: '=',
        validationError: '<',
        disabled: '<',
        required: '<',
        placeholderKey: '<',
        hintKey: '<',
        labelNoFloat: '<'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoInputDate.js